import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const Relationship = createSvgIcon(
  <svg width="18px" height="10px" viewBox="0 0 18 10" version="1.1">
    <defs>
      <path
        d="M1.66666667,6.24147139 L3.09561224,6.24147139 L3.09561224,4.90823583 L1.66666667,4.90823583 L1.66666667,6.24147139 Z M1.66666667,3.83323555 L3.09561224,3.83323555 L3.09561224,2.5 L1.66666667,2.5 L1.66666667,3.83323555 Z M1.66666667,8.64970639 L3.09561224,8.64970639 L3.09561224,7.31647083 L1.66666667,7.31647083 L1.66666667,8.64970639 Z M9.16666667,11.3332356 L10.5956122,11.3332356 L10.5956122,10 L9.16666667,10 L9.16666667,11.3332356 Z M11.6666667,11.3332356 L13.0956122,11.3332356 L13.0956122,10 L11.6666667,10 L11.6666667,11.3332356 Z M14.1666667,11.3332356 L15.5956122,11.3332356 L15.5956122,10 L14.1666667,10 L14.1666667,11.3332356 Z M16.6666667,11.3332356 L18.0956122,11.3332356 L18.0956122,10 L16.6666667,10 L16.6666667,11.3332356 Z M6.66666667,11.3332356 L8.09508844,11.3332356 L8.09508844,10 L6.66666667,10 L6.66666667,11.3332356 Z M4.16666667,11.3332356 L5.59508844,11.3332356 L5.59508844,10 L4.16666667,10 L4.16666667,11.3332356 Z M1.66666667,10 C1.66666667,10.732864 2.30937789,11.3332356 3.09508844,11.3332356 L3.09508844,11.3332356 L3.09508844,10 L1.66666667,10 Z"
        id="relationship-path-1"
      ></path>
    </defs>
    <g id="relationship-Map-Data" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="relationship-Map-Data-on-focus-wMapping" transform="translate(-598.000000, -703.000000)">
        <g id="relationship-Group-4" transform="translate(582.000000, 633.000000)">
          <g id="relationship-Group-5" transform="translate(0.000000, 16.000000)">
            <g id="relationship-Group-9" transform="translate(11.000000, 13.000000)">
              <g id="ic_TreeBranch" transform="translate(4.000000, 39.000000)">
                <use id="Mask" fill="#000000" fillRule="evenodd" href="#relationship-path-1"></use>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>,
  'Relationship'
);
